var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuineaBissau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.0341797C14.5559 0.0341797 13.1569 0.22668 11.8261 0.585367L10.4348 16.0342L11.8261 31.483C13.1569 31.8417 14.5559 32.0342 16 32.0342C24.8365 32.0342 32 24.8707 32 16.0342C32 7.19768 24.8365 0.0341797 16 0.0341797Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4348 16.0342L11.8261 31.483C13.1569 31.8417 14.5559 32.0342 16 32.0342C24.8365 32.0342 32 24.8707 32 16.0342H10.4348Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0342C0 22.0989 3.37438 27.3752 8.34781 30.0888V1.97966C3.37438 4.69328 0 9.96953 0 16.0342Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.0339C0 23.4263 5.01381 29.6467 11.8261 31.4827V0.585052C5.01381 2.42105 0 8.64143 0 16.0339Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0464 11.8604L7.08234 15.0489H10.4352L7.72284 17.0197L8.75871 20.2083L6.0464 18.2376L3.33396 20.2083L4.37009 17.0197L1.65771 15.0489H5.0104L6.0464 11.8604Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuineaBissau);
export default __webpack_public_path__ + "static/media/guinea-bissau.165bab2c.svg";
export { ForwardRef as ReactComponent };